import { useI18n } from '@/js/i18n';

export default {
  setup() {
    const i18n = useI18n();
    return {
      i18n,
    };
  },
};

/**
 * 共用主版面導覽旅程路由列表
 * @param {*} i18n
 * @returns
 */
export function getLayoutDriverTourRouteList(i18n) {
  const dataList = [
    {
      id: 'selectLanguage',
      functionName: i18n.$t('Layout').switchLanguage,
      description: i18n.$t('Layout').switchLanguageExplain,
      driverTourName: 'callHelp_selectLanguage',
      routePath: '',
    },
    {
      id: 'switchFactory',
      functionName: i18n.$t('Layout').switchFactory,
      description: i18n.$t('Layout').switchFactoryDescription,
      driverTourName: 'callHelp_switchFactory',
      routePath: '',
    },
    {
      id: 'viewProfile',
      functionName: i18n.$t('Layout').profile,
      description: ' ',
      driverTourName: 'callHelp_viewProfile',
      routePath: '',
    },
    {
      id: 'logout',
      functionName: i18n.$t('Layout').logout,
      description: ' ',
      driverTourName: 'callHelp_logout',
      routePath: '',
    },
    {
      id: 'where_online_list',
      functionName: i18n.$t('OnlineStatus').online_list,
      description: i18n.$t('OnlineStatus').where_online_list,
      driverTourName: 'callHelp_logout',
      routePath: '',
    },
  ];
  return dataList;
}

/**
 * 取得導覽旅程路由列表供系統用
 * @param {*} i18n
 * @returns
 */
export function getDriverTourRouteListForSystem(i18n) {
  /** 智慧導覽助理路由列表 */
  const driverTourRouteList = [
    {
      id: 'addFactory',
      functionName: i18n.$t('System_As_2').addFactory,
      description: i18n.$t('System_As_2').addFactoryAndConnectDB,
      driverTourName: 'callHelp_System',
      routePath: '/system/As_2',
    },
    {
      id: 'editFactory',
      functionName: i18n.$t('System_As_2').editFactory,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/As_2',
    },
    {
      id: 'filterFactory',
      functionName: i18n.$t('System_As_2').filterFactory,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/As_2',
    },
    {
      id: 'deleteFactory',
      functionName: i18n.$t('System_As_2').deleteFactory,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/As_2',
    },

    {
      id: 'createSeasonSetting',
      functionName: i18n.$t('System_As_3').CreateReviewSchedule,
      description: i18n.$t('System_As_3').ReviewScheduleDescription,
      driverTourName: 'callHelp_System',
      routePath: '/system/As_3',
    },
    {
      id: 'editSeasonSetting',
      functionName: i18n.$t('System_As_3').EditReviewSchedule,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/As_3',
    },
    {
      id: 'deleteSeasonSetting',
      functionName: i18n.$t('System_As_3').DeleteReviewSchedule,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/As_3',
    },
    {
      id: 'filterSeasonSetting',
      functionName: i18n.$t('System_As_3').FilterReviewSchedule,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/As_3',
    },
    {
      id: 'nextExecuteSchedule',
      functionName: i18n.$t('System_As_3').nextExecuteSchedule,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/As_3',
    },
    {
      id: 'systemKey',
      functionName: i18n.$t('System').systemKey,
      description: i18n.$t('System').systemKeyExplain,
      driverTourName: 'callHelp_System',
      routePath: '/system/As_3',
    },

    {
      id: 'createBasicAuthoritySetting',
      functionName: i18n.$t('System_Bs_1').CreateBasicAuthoritySetting,
      description: i18n.$t('System_Bs_1').CreateBasicAuthoritySettingDescription,
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_1',
    },
    {
      id: 'editBasicAuthoritySetting',
      functionName: i18n.$t('System_Bs_1').EditBasicAuthoritySetting,
      description: '',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_1',
    },
    {
      id: 'authority',
      functionName: i18n.$t('System_Bs_1').Authority,
      description: '',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_1',
    },
    {
      id: 'deleteBasicAuthoritySetting',
      functionName: i18n.$t('System_Bs_1').DeleteBasicAuthoritySetting,
      description: '',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_1',
    },
    {
      id: 'filterBasicAuthoritySetting',
      functionName: i18n.$t('System_Bs_1').FilterBasicAuthoritySetting,
      description: '',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_1',
    },

    {
      id: 'createBuUser',
      functionName: i18n.$t('System_Bs_2').CreateBuUser,
      description: i18n.$t('System_Bs_2').CreateBuUserDescription,
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_2',
    },
    {
      id: 'editBuUser',
      functionName: i18n.$t('System_Bs_2').EditBuUser,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_2',
    },
    {
      id: 'deleteBuUser',
      functionName: i18n.$t('System_Bs_2').DeleteBuUser,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_2',
    },
    {
      id: 'filterBuUser',
      functionName: i18n.$t('System_Bs_2').FilterBuUser,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_2',
    },

    {
      id: 'createAccount',
      functionName: i18n.$t('System_Bs_3').CreateAccount,
      description: i18n.$t('System_Bs_3').CreateAccountDescription,
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_3',
    },

    {
      id: 'editAccount',
      functionName: i18n.$t('System_Bs_3').EditAccount,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_3',
    },

    {
      id: 'modifyPassword',
      functionName: i18n.$t('System_Bs_3').ModifyPassword,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_3',
    },

    {
      id: 'deleteAccount',
      functionName: i18n.$t('System_Bs_3').DeleteAccount,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_3',
    },

    {
      id: 'filterAccount',
      functionName: i18n.$t('System_Bs_3').FilterAccount,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_3',
    },

    {
      id: 'syncAccount',
      functionName: i18n.$t('System_Bs_3').SyncAccount,
      description: ' ',
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_3',
    },

    {
      id: 'dataImport',
      functionName: i18n.$t('System_Bs_4').DataImport,
      description: i18n.$t('System_Bs_4').DataImportDescription,
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_4',
    },

    {
      id: 'accountManagementExcel',
      functionName: i18n.$t('System_Bs_4').accountManagementTemplate,
      description: i18n.$t('System_Bs_4').accountManagementTemplateExplain,
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_4',
    },

    {
      id: 'buUserSettingManagementExcel',
      functionName: i18n.$t('System_Bs_4').buUserSettingTemplate,
      description: i18n.$t('System_Bs_4').buUserSettingTemplateExplain,
      driverTourName: 'callHelp_System',
      routePath: '/system/Bs_4',
    },

    {
      id: 'mailNotify',
      functionName: i18n.$t('System_Cs_2').mailNotify,
      description: i18n.$t('System_Cs_2').mailNotifyDescription,
      driverTourName: 'callHelp_System',
      routePath: '/system/Cs_2',
    },

    {
      id: 'weChatNotify',
      functionName: i18n.$t('System_Cs_3').weChatNotify,
      description: i18n.$t('System_Cs_3').weChatNotifyDescription,
      driverTourName: 'callHelp_System',
      routePath: '/system/Cs_3',
    },
  ];

  const commonLayoutDriverTourRouteList = getLayoutDriverTourRouteList(i18n);
  const newArray = driverTourRouteList.concat(commonLayoutDriverTourRouteList);

  return newArray;
}

/**
 * 取得導覽旅程路由列表供登入用
 * @param {*} i18n
 * @returns
 */
export function getDriverTourRouteListForLogin(i18n) {
  const driverTourRouteList = [
    {
      id: 'login',
      functionName: i18n.$t('Menu').login_text,
      description: i18n.$t('LoginPage').Description,
      driverTourName: 'callHelp_Login',
      routePath: '/login',
    },
    {
      id: 'explain_noAccount',
      functionName: i18n.$t('LoginPage').NoAnyHaveAccount,
      description: i18n.$t('LoginPage').HowTheNoAnyHaveAccount,
      driverTourName: 'callHelp_noAccount',
      routePath: '/login',
    },
    {
      id: 'explain_SPCLoginError',
      functionName: i18n.$t('LoginPage').SPCLoginErrorMessage,
      description: i18n.$t('LoginPage').SPCLoginErrorMessageExplain,
      driverTourName: 'callHelp_SPCLoginError',
      routePath: '/login',
    },
    {
      id: 'onlineList',
      functionName: i18n.$t('Layout').onlineList,
      description: i18n.$t('Layout').onlineListTitle,
      driverTourName: 'callHelp_logout',
      routePath: '',
    },
  ];
  return driverTourRouteList;
}

/**
 * 取得取得導覽旅程路由列表供Business Units用
 * @param {*} i18n
 * @returns
 */
export function getBU(i18n) {
  const mainMenu = JSON.parse(sessionStorage.getItem('MainMenu') || '[]');
  const findControlItem = mainMenu.find((x) => x.code === 'A_0');
  const findControlItemSubItem = findControlItem?.subitems?.find((x) => x.code === 'A_1');

  const driverTourRouteList = [
    {
      id: 'dashboard',
      functionName: i18n.$t('Dashboard').dashboard,
      description: i18n.$t('Dashboard').dashboardDescription,
      driverTourName: 'callHelp_Dashboard',
      routePath: '/dashboard',
    },
    {
      id: 'samplePointView',
      functionName: i18n.$t('Dashboard').SamplePointView,
      description: i18n.$t('Dashboard').SamplePointViewExplain,
      driverTourName: 'callHelp_Dashboard',
      routePath: '/dashboard',
    },

    {
      id: 'menuOtherFunction',
      functionName: i18n.$t('Dashboard').MenuOtherFunction,
      description: i18n.$t('Dashboard').MenuOtherFunctionDescription,
      driverTourName: 'callHelpMenuOtherFunction',
      routePath: '/dashboard',
    },

    //
    // 人員管理
    //

    // 使用者群組設定
    {
      id: 'userGroupSettings',
      functionName: i18n.$t('MemberManagement').userGroupSettings.name,
      description: i18n.$t('MemberManagement').userGroupSettings.description,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_1',
    },

    {
      id: 'editUserGroupSettings',
      functionName: i18n.$t('MemberManagement').userGroupSettings.edit,
      description: i18n.$t('MemberManagement').userGroupSettings.editExplain,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_1',
    },

    {
      id: 'userGroupSettingsUser',
      functionName: i18n.$t('MemberManagement').userGroupSettings.user,
      description: i18n.$t('MemberManagement').userGroupSettings.userDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_1',
    },

    {
      id: 'userGroupSettingsPermission',
      functionName: i18n.$t('MemberManagement').userGroupSettings.permission,
      description: i18n.$t('MemberManagement').userGroupSettings.permissionDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_1',
    },

    {
      id: 'userGroupSettingsForbidden',
      functionName: i18n.$t('MemberManagement').userGroupSettings.forbiddenControllItem,
      description: i18n.$t('MemberManagement').userGroupSettings.forbiddenControllItemDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_1',
    },

    {
      id: 'userGroupSettingsOther',
      functionName: i18n.$t('MemberManagement').userGroupSettings.other,
      description: i18n.$t('MemberManagement').userGroupSettings.otherDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_1',
    },

    {
      id: 'deleteUserGroupSettings',
      functionName: i18n.$t('MemberManagement').userGroupSettings.delete,
      description: i18n.$t('MemberManagement').userGroupSettings.deleteExplain,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_1',
    },

    {
      id: 'filterUserGroupSettings',
      functionName: i18n.$t('MemberManagement').userGroupSettings.filter,
      description: i18n.$t('MemberManagement').userGroupSettings.filterExplain,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_1',
    },

    {
      id: 'userSettings',
      functionName: i18n.$t('MemberManagement').userSettings.name,
      description: i18n.$t('MemberManagement').userSettings.description,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_2',
    },

    {
      id: 'viewUserSettings',
      functionName: i18n.$t('MemberManagement').userSettings.view,
      description: i18n.$t('MemberManagement').userSettings.viewDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_2',
    },

    {
      id: 'userSettingsGroup',
      functionName: i18n.$t('MemberManagement').userSettings.group,
      description: i18n.$t('MemberManagement').userSettings.groupDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_2',
    },

    {
      id: 'userSettingsPermission',
      functionName: i18n.$t('MemberManagement').userSettings.permission,
      description: i18n.$t('MemberManagement').userSettings.permissionDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_2',
    },

    {
      id: 'userSettingsForbidden',
      functionName: i18n.$t('MemberManagement').userSettings.forbiddenControllItem,
      description: i18n.$t('MemberManagement').userSettings.forbiddenControllItemDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_2',
    },

    {
      id: 'userSettingsOtherFunction',
      functionName: i18n.$t('MemberManagement').userSettings.other,
      description: i18n.$t('MemberManagement').userSettings.otherDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_2',
    },

    {
      id: 'deleteUserSettings',
      functionName: i18n.$t('MemberManagement').userSettings.delete,
      description: i18n.$t('MemberManagement').userSettings.deleteDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_2',
    },

    {
      id: 'filterUserSettings',
      functionName: i18n.$t('MemberManagement').userSettings.filter,
      description: i18n.$t('MemberManagement').userSettings.filterExplain,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/C_2',
    },

    {
      id: 'notificationSettings',
      functionName: i18n.$t('MemberManagement').notificationSettings.name,
      description: i18n.$t('MemberManagement').notificationSettings.description,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/D_2',
    },

    {
      id: 'editNotificationSettings',
      functionName: i18n.$t('MemberManagement').notificationSettings.edit,
      description: i18n.$t('MemberManagement').notificationSettings.editDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/D_2',
    },

    {
      id: 'notificationSettingsGroup',
      functionName: i18n.$t('MemberManagement').notificationSettings.group,
      description: i18n.$t('MemberManagement').notificationSettings.groupDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/D_2',
    },

    {
      id: 'notificationSettingsMemberManagement',
      functionName: i18n.$t('MemberManagement').notificationSettings.memberManagement,
      description: i18n.$t('MemberManagement').notificationSettings.memberManagementDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/D_2',
    },

    {
      id: 'deleteNotificationSettings',
      functionName: i18n.$t('MemberManagement').notificationSettings.delete,
      description: i18n.$t('MemberManagement').notificationSettings.deleteDescription,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/D_2',
    },

    {
      id: 'filterNotificationSettings',
      functionName: i18n.$t('MemberManagement').notificationSettings.filter,
      description: i18n.$t('MemberManagement').notificationSettings.filterExplain,
      driverTourName: 'callHelp_MemberManagement',
      routePath: '/D_2',
    },

    //
    // 管制項目設定
    //

    {
      id: 'filterControlItemTree',
      functionName: i18n.$t('ControlItem').Setting.filter,
      description: i18n.$t('ControlItem').Setting.filterExplain,
      driverTourName: 'callHelp_ControlItemSettings',
      routePath: '/A_1',
    },

    ...(findControlItemSubItem?.component === 'views/A_0/A_1'
      ? [
          {
            id: 'ControlItemTab',
            functionName: i18n.$t('ControlItem').Setting.create,
            description: i18n.$t('ControlItem').Setting.createDescription,
            driverTourName: 'callHelp_ControlItemSettings',
            routePath: '/A_1',
          },
        ]
      : []),

    ...(findControlItemSubItem?.component === 'views/A_0/A_1_V1'
      ? [
          {
            id: 'addControlItem',
            functionName: i18n.$t('ControlItem').Setting.create,
            description: i18n.$t('ControlItem').Setting.createDescription,
            driverTourName: 'callHelp_ControlItemSettings',
            routePath: '/A_1',
          },
        ]
      : []),

    {
      id: 'controlItemSettingAndChartRule',
      functionName: i18n.$t('ControlItem').Setting.controlChartSetting,
      description: i18n.$t('ControlItem').Setting.controlItemSettingAndChartRule,
      driverTourName: 'callHelp_ControlItemSettings',
      routePath: '/A_1',
    },

    {
      id: 'doubleChart',
      functionName: i18n.$t('ControlItem').Setting.doubleChartTitle,
      description: i18n.$t('ControlItem').Setting.doubleChartDescription,
      driverTourName: 'callHelp_ControlItemSettings',
      routePath: '/A_1',
    },

    {
      id: 'copyControlItem',
      functionName: i18n.$t('ControlItem').Setting.copy,
      description: i18n.$t('ControlItem').Setting.copyDescription,
      driverTourName: 'callHelp_ControlItemSettings',
      routePath: '/A_1',
    },

    {
      id: 'reCaculateontrolItem',
      functionName: i18n.$t('ControlItem').Setting.reCaculate,
      description: i18n.$t('ControlItem').Setting.reCaculateDescription,
      driverTourName: 'callHelp_ControlItemSettings',
      routePath: '/A_1',
    },

    {
      id: 'editControlItem',
      functionName: i18n.$t('ControlItem').Setting.edit,
      description: i18n.$t('ControlItem').Setting.editDescription,
      driverTourName: 'callHelp_ControlItemSettings',
      routePath: '/A_1',
    },

    {
      id: 'deleteControlItem',
      functionName: i18n.$t('ControlItem').Setting.delete,
      description: i18n.$t('ControlItem').Setting.deleteDescription,
      driverTourName: 'callHelp_ControlItemSettings',
      routePath: '/A_1',
    },

    {
      id: 'explanationOfTheTerm',
      functionName: i18n.$t('ControlItem').Setting.explanationOfTheTerm,
      description: i18n.$t('ControlItem').Setting.explanationOfTheTermDescription,
      driverTourName: 'callHelp_ControlItemSettings',
      routePath: '/A_1',
    },

    //
    // 管制項目資訊
    //

    {
      id: 'filterControlProjectInfo',
      functionName: i18n.$t('ControlItem').Information.filter,
      description: i18n.$t('ControlItem').Information.filterDescription,
      driverTourName: 'callHelp_ControlItemInformation',
      routePath: '/A_2',
    },

    {
      id: 'controlProjectInfo-View',
      functionName: i18n.$t('ControlItem').Information.controlProjectInfoView,
      description: i18n.$t('ControlItem').Information.controlProjectInfoViewDescription,
      driverTourName: 'callHelp_ControlItemInformation',
      routePath: '/A_2',
    },

    {
      id: 'hidePointOpen',
      functionName: i18n.$t('ControlItem').Information.hidePointOpen,
      driverTourName: 'callHelp_ControlItemInformation',
      routePath: '/A_2',
    },

    {
      id: 'clickChartSamplePoint',
      functionName: i18n.$t('ControlItem').Information.clickChartSamplePoint,
      driverTourName: 'callHelp_ControlItemInformation',
      routePath: '/A_2',
    },

    //
    // 管制項目寫入
    //
    {
      id: 'controlItemEntry',
      functionName: i18n.$t('ControlItem').ControlItemEntry.name,
      description: i18n.$t('ControlItem').ControlItemEntry.description,
      driverTourName: 'callHelp_ControlItemEntry',
      routePath: '/A_6',
    },

    {
      id: 'controlItemEntryDataImport',
      functionName: i18n.$t('ControlItem').ControlItemEntry.ControlItemEntryDataImport,
      description: i18n.$t('ControlItem').ControlItemEntry.ControlItemEntryDataImport,
      driverTourName: 'callHelp_ControlItemEntry',
      routePath: '/A_6',
    },

    {
      id: 'multiDataImport',
      functionName: i18n.$t('ControlItem').ControlItemEntry.ControlItemEntryBatchImport,
      description: i18n.$t('ControlItem').ControlItemEntry.ControlItemEntryBatchImportExplain,
      driverTourName: 'callHelp_ControlItemEntry',
      routePath: '/A_6',
    },

    {
      id: 'sampleManagement',
      functionName: `${i18n.$t('ControlItem').SampleSetting.sampleManagement}-${
        i18n.$t('ControlItem').SampleSetting.hiddenPointProcess
      }`,
      description: i18n.$t('ControlItem').SampleSetting.hiddenPointProcessDescription,
      driverTourName: 'callHelp_SampleSetting',
      routePath: '/A_7',
    },

    {
      id: 'sampleManagementEditPointProcess',
      functionName: `${i18n.$t('ControlItem').SampleSetting.sampleManagement}-${
        i18n.$t('ControlItem').SampleSetting.editPointProcess
      }`,
      description: i18n.$t('ControlItem').SampleSetting.editPointProcessDescription,
      driverTourName: 'callHelp_SampleSetting',
      routePath: '/A_7',
    },

    //
    // 變更履歷
    //
    {
      id: 'controlLineChangeHistory',
      functionName: i18n.$t('ControlItem').History.ControlLineChangeHistory,
      description: i18n.$t('ControlItem').History.ControlLineChangeHistoryDescription,
      driverTourName: 'callHelp_changeHistory',
      routePath: '/A_4',
    },

    {
      id: 'controlChartRuleHistory',
      functionName: i18n.$t('ControlItem').History.ControlChartRuleHistory,
      description: i18n.$t('ControlItem').History.ControlChartRuleHistoryDescription,
      driverTourName: 'callHelp_changeHistory',
      routePath: '/A_4',
    },

    //
    // 合圖查詢
    //
    {
      id: 'combinedQuery',
      functionName: i18n.$t('ControlItem').CombinedQuery.name,
      description: i18n.$t('ControlItem').CombinedQuery.description,
      driverTourName: 'callHelp_combinedQuery',
      routePath: '/A_5',
    },

    //
    // 製程能力分析
    //
    {
      id: 'processAnalysis',
      functionName: i18n.$t('ControlItem').ProcessAnalysis.name,
      description: i18n.$t('ControlItem').ProcessAnalysis.name,
      driverTourName: 'callHelp_processAnalysis',
      routePath: '/A_3',
    },

    {
      id: 'reportAdvanceSearch',
      functionName: i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearch,
      description: i18n.$t('ControlItem').ProcessAnalysis.reportAdvanceSearchExplain,
      driverTourName: 'callHelp_processAnalysis',
      routePath: '/A_3',
    },

    {
      id: 'chartQuery',
      functionName: i18n.$t('ControlItem').ProcessAnalysis.Chart,
      description: i18n.$t('ControlItem').ProcessAnalysis.ChartDescription,
      driverTourName: 'callHelp_processAnalysis',
      routePath: '/A_3',
    },

    {
      id: 'processAnalysisAbnormal',
      functionName: i18n.$t('ControlItem').ProcessAnalysis.Abnormal,
      description: i18n.$t('ControlItem').ProcessAnalysis.AbnormalDescription,
      driverTourName: 'callHelp_processAnalysis',
      routePath: '/A_3',
    },

    //
    // 異常原因管理
    //
    {
      id: 'abnormalReasonManagement',
      functionName: i18n.$t('SettingManagement').AbnormalReasonManagement,
      description: i18n.$t('SettingManagement').AbnormalReasonManagementDescription,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },
    {
      id: 'editAbnormalReasonManagement',
      functionName: i18n.$t('SettingManagement').EditAbnormalReason,
      description: i18n.$t('SettingManagement').EditAbnormalReasonExplain,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },
    {
      id: 'deleteAbnormalReasonManagement',
      functionName: i18n.$t('SettingManagement').DeleteAbnormalReason,
      description: i18n.$t('SettingManagement').DeleteAbnormalReasonExplain,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },

    {
      id: 'defectDefinition',
      functionName: i18n.$t('SettingManagement').DefectDefinition,
      description: i18n.$t('SettingManagement').DefectDefinitionDescription,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },
    {
      id: 'editDefectDefinition',
      functionName: i18n.$t('SettingManagement').EditDefectDefinition,
      description: i18n.$t('SettingManagement').EditDefectDefinitionExplain,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },
    {
      id: 'deleteDefectDefinition',
      functionName: i18n.$t('SettingManagement').DeleteDefectDefinition,
      description: i18n.$t('SettingManagement').DeleteDefectDefinitionExplain,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },

    {
      id: 'inspection',
      functionName: i18n.$t('SettingManagement').Inspection,
      description: i18n.$t('SettingManagement').InspectionDescription,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },

    {
      id: 'editInspection',
      functionName: i18n.$t('SettingManagement').EditInspection,
      description: i18n.$t('SettingManagement').EditInspectionExplain,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },

    {
      id: 'deleteInspection',
      functionName: i18n.$t('SettingManagement').DeleteInspection,
      description: i18n.$t('SettingManagement').DeleteInspectionExplain,
      driverTourName: 'callHelp_abnormalReasonManagement',
      routePath: '/B_1',
    },

    //
    // 層別設定
    //

    {
      id: 'levelProduct',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.product,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.productDescription,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'editLevelProduct',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.editProduct,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.editProductExplain,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'deleteLevelProduct',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.deleteProduct,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.deleteProductExplain,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'levelMachine',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.machine,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.machineDescription,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'editLevelMachine',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.editMachine,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.editMachineExplain,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'deleteLevelMachine',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.deleteMachine,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.deleteMachineExplain,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'levelProcess',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.group,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.groupDescription,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'editLevelProcess',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.editProcess,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.editProcessExplain,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'deleteLevelProcess',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.deleteProcess,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.deleteProcessExplain,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'levelParams',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.parameters,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.parametersDescription,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'editLevelParams',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.editParams,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.editParamsExplain,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    {
      id: 'deleteLevelParams',
      functionName: i18n.$t('SettingManagement').LevelTypeDefinition.deleteParams,
      description: i18n.$t('SettingManagement').LevelTypeDefinition.deleteParamsExplain,
      driverTourName: 'callHelp_LevelTypeDefinition',
      routePath: '/B_3',
    },

    //
    // 動態欄位設定
    //
    {
      id: 'dynamicFieldSettings',
      functionName: i18n.$t('SettingManagement').DynamicFieldSettings.name,
      description: i18n.$t('SettingManagement').DynamicFieldSettings.description,
      driverTourName: 'callHelp_DynamicFieldSettings',
      routePath: '/B_4',
    },

    //
    // 管制圖規則
    //
    {
      id: 'controlChartRules',
      functionName: i18n.$t('SettingManagement').ControlChartRules.name,
      description: i18n.$t('SettingManagement').ControlChartRules.description,
      driverTourName: 'callHelp_ControlChartRules',
      routePath: '/B_2',
    },

    {
      id: 'editAndDeleteControlChartRules',
      functionName: i18n.$t('SettingManagement').ControlChartRules.editAndDelete,
      description: i18n.$t('SettingManagement').ControlChartRules.editAndDeleteExplain,
      driverTourName: 'callHelp_ControlChartRules',
      routePath: '/B_2',
    },

    //
    // 標準樣本設定
    //
    {
      id: 'goldenSampleSetting',
      functionName: i18n.$t('SettingManagement').GoldenSampleSetting.name,
      description: i18n.$t('SettingManagement').GoldenSampleSetting.description,
      driverTourName: 'callHelp_GoldenSampleSetting',
      routePath: '/B_6',
    },

    {
      id: 'goldenSampleSettingEditAndDelete',
      functionName: i18n.$t('SettingManagement').GoldenSampleSetting.editAndDelete,
      description: i18n.$t('SettingManagement').GoldenSampleSetting.editAndDeleteExplain,
      driverTourName: 'callHelp_GoldenSampleSetting',
      routePath: '/B_6',
    },

    //
    // 制程能力等級
    //
    {
      id: 'processAnalysisRanks',
      functionName: i18n.$t('SettingManagement').ProcessAnalysisRanks.name,
      description: i18n.$t('SettingManagement').ProcessAnalysisRanks.description,
      driverTourName: 'callHelp_ProcessAnalysisRanks',
      routePath: '/B_8',
    },

    {
      id: 'processAnalysisRanksEditAndDelete',
      functionName: i18n.$t('SettingManagement').ProcessAnalysisRanks.editAndDelete,
      description: i18n.$t('SettingManagement').ProcessAnalysisRanks.editAndDeleteExplain,
      driverTourName: 'callHelp_ProcessAnalysisRanks',
      routePath: '/B_8',
    },

    //
    // 製程能力規則
    //
    {
      id: 'processAnalysisRule',
      functionName: i18n.$t('SettingManagement').ProcessAnalysisRule.name,
      description: i18n.$t('SettingManagement').ProcessAnalysisRule.description,
      driverTourName: 'callHelp_ProcessAnalysisRule',
      routePath: '/B_9',
    },

    {
      id: 'processAnalysisRuleEditAndDelete',
      functionName: i18n.$t('SettingManagement').ProcessAnalysisRule.editAndDelete,
      description: i18n.$t('SettingManagement').ProcessAnalysisRule.editAndDelete,
      driverTourName: 'callHelp_ProcessAnalysisRule',
      routePath: '/B_9',
    },

    //
    // Indicator設定
    //
    {
      id: 'indicator',
      functionName: i18n.$t('SettingManagement').Indicator.name,
      description: i18n.$t('SettingManagement').Indicator.description,
      driverTourName: 'callHelp_Indicator',
      routePath: '/B_10',
    },

    {
      id: 'indicatorQA',
      functionName: i18n.$t('SettingManagement').Indicator.qa,
      description: i18n.$t('SettingManagement').Indicator.qaExplain,
      driverTourName: 'callHelp_Indicator',
      routePath: '/B_10',
    },

    //
    // 排程設定
    //
    {
      id: 'scheduleSettings',
      functionName: i18n.$t('SettingManagement').ScheduleSettings.name,
      description: i18n.$t('SettingManagement').ScheduleSettings.description,
      driverTourName: 'callHelp_Indicator',
      routePath: '/B_11',
    },

    {
      id: 'scheduleSettingsList',
      functionName: i18n.$t('SettingManagement').ScheduleSettings.listTitle,
      description: i18n.$t('SettingManagement').ScheduleSettings.listTitle,
      driverTourName: 'callHelp_Indicator',
      routePath: '/B_11',
    },

    //
    // OCAP
    //
    {
      id: 'stageSetting',
      functionName: i18n.$t('OCAP').stageSetting,
      description: i18n.$t('OCAP').stageSetting,
      driverTourName: 'callHelp_OCAP',
      routePath: '/F_1',
    },

    {
      id: 'editDeleteStageSetting',
      functionName: i18n.$t('OCAP').editDeleteStageSetting,
      description: i18n.$t('OCAP').editDeleteStageSetting,
      driverTourName: 'callHelp_OCAP',
      routePath: '/F_1',
    },

    {
      id: 'flowSetting',
      functionName: i18n.$t('OCAP').OCAP_FlowSetting,
      description: i18n.$t('OCAP').OCAP_FlowSetting,
      driverTourName: 'callHelp_OCAP',
      routePath: '/F_2',
    },

    {
      id: 'stageSettingExample',
      functionName: i18n.$t('OCAP').settingExample,
      description: i18n.$t('OCAP').settingExampleExplain,
      driverTourName: 'callHelp_OCAP',
      routePath: '/F_1',
    },

    {
      id: 'signatureQuery',
      functionName: i18n.$t('OCAP').SignatureQuery.name,
      description: i18n.$t('OCAP').SignatureQuery.description,
      driverTourName: 'callHelpSignatureQuery',
      routePath: '/F_3',
    },

    {
      id: 'signatureQueryHandle',
      functionName: `${i18n.$t('OCAP').SignatureQuery.name}-${
        i18n.$t('OCAP').SignatureQuery.handle
      }`,
      description: i18n.$t('OCAP').SignatureQuery.handleExplain,
      driverTourName: 'callHelpSignatureQuery',
      routePath: '/F_3',
    },

    //
    // 警報管理
    //
    {
      id: 'alarmList',
      functionName: i18n.$t('AlarmList').name,
      description: i18n.$t('AlarmList').description,
      driverTourName: 'callHelpAlarmList',
      routePath: '/D_1',
    },

    {
      id: 'alarmListAdvanceSearch',
      functionName: i18n.$t('AlarmList').advanceSearch,
      description: i18n.$t('AlarmList').advanceSearchExplain,
      driverTourName: 'callHelpAlarmList',
      routePath: '/D_1',
    },

    {
      id: 'alarmListLamp',
      functionName: i18n.$t('AlarmList').lamp,
      description: i18n.$t('AlarmList').lampExplain,
      driverTourName: 'callHelpAlarmList',
      routePath: '/D_1',
    },

    {
      id: 'alarmListHandle',
      functionName: i18n.$t('AlarmList').handle,
      description: i18n.$t('AlarmList').handleExplain,
      driverTourName: 'callHelpAlarmList',
      routePath: '/D_1',
    },

    {
      id: 'processAnalysisAlarmList',
      functionName: i18n.$t('ProcessAnalysisAlarmList').name,
      description: i18n.$t('ProcessAnalysisAlarmList').description,
      driverTourName: 'callHelpProcessAnalysisAlarmList',
      routePath: '/D_1',
    },

    //
    // 資料處理-資料匯入
    //
    {
      id: 'dataImport',
      functionName: i18n.$t('DataImport').dataProcessingImport,
      description: i18n.$t('DataImport').description,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportAbnormalReason',
      functionName: i18n.$t('DataImport').dataImportAbnormalReasonExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportDefect',
      functionName: i18n.$t('DataImport').dataImportDefectExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportInspection',
      functionName: i18n.$t('DataImport').dataImportInspectionExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportControlChartRules',
      functionName: i18n.$t('DataImport').dataImportControlChartRulesExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportUserSettings',
      functionName: i18n.$t('DataImport').dataImportUserSettingsExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportUserGroup',
      functionName: i18n.$t('DataImport').dataImportUserGroupExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportParameters',
      functionName: i18n.$t('DataImport').dataImportParametersExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportGroup',
      functionName: i18n.$t('DataImport').dataImportGroupExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportMachine',
      functionName: i18n.$t('DataImport').dataImportMachineExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    {
      id: 'dataImportProduct',
      functionName: i18n.$t('DataImport').dataImportProductExample,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_1',
    },

    //
    // 資料處理-管制項目匯入
    //
    {
      id: 'controlItemImport',
      functionName: i18n.$t('ControlItemImport').name,
      description: i18n.$t('ControlItemImport').description,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_2',
    },
    {
      id: 'controlItemBatchImport',
      functionName: i18n.$t('ControlItemImport').batchImport,
      description: i18n.$t('ControlItemImport').batchImportDescription,
      driverTourName: 'callHelpDataImport',
      routePath: '/E_2',
    },

    //
    // SPC統計管制圖 說明
    //
    {
      id: 'xBarChart',
      functionName: "XBar-Chart",
      description: i18n.$t('statisticalControlChart').xBarChartDescription,
      driverTourName: 'callxBarChart',
      routePath: '/A_1',
    },
  ];
  return driverTourRouteList;
}
